var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"a-submitButton"},[_c('button',_vm._g(_vm._b({ref:"button",staticClass:"a-submitButton__button"},'button',_vm.$attrs,false),_vm.$listeners),[_c('span',{ref:"text",staticClass:"a-submitButton__text",class:{'--loading' : _vm.loading}},[_vm._v(_vm._s(_vm.text))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }